<script setup lang="ts">
import type { QueueTrack } from '~/composables/audio/queue'
import type { Track } from '~/types'

import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { useStore } from '~/store'

import Button from '~/ui/Button.vue'

interface Props {
  track?: Track | QueueTrack
  // TODO: What does `button` mean? Apparently either way we render a button?
  button?: boolean
  border?: boolean
}

// TODO: Remove this. It mirrors exactly the defaulting behavior for Vue props (undefined for optional props, false for optional booleans).
withDefaults(defineProps<Props>(), {
  track: undefined,
  button: false,
  border: false
})

const store = useStore()
const { t } = useI18n()

// TODO:Remove indirection
const labels = computed(() => ({
  addToPlaylist: t('components.playlists.TrackPlaylistIcon.button.add')
}))
</script>

<template>
  <Button
    v-if="button"
    class="color-primary-solid"
    @click.stop="store.commit('playlists/chooseTrack', track)"
  >
    <Icon icon="mdi:playlist-plus" />
    {{ t('components.playlists.TrackPlaylistIcon.button.add') }}
  </Button>
  <Button
    v-else
    class="shape-square"
    :aria-label="labels.addToPlaylist"
    :title="labels.addToPlaylist"
    @click.stop="store.commit('playlists/chooseTrack', track)"
  >
    <Icon icon="mdi:playlist-plus" />
  </Button>
</template>
